/* Oasis — email link fallback.
   Email links on the Contact page still try to open the customer's email app.
   Because many people have no email app set up (they use Gmail/Outlook in the browser),
   we also copy the address and show a small panel with one-click Gmail / Outlook options. */
(function () {
  var STYLE = '.oa-mail-toast{position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:100000;max-width:calc(100% - 32px);width:420px;background:#F6EEE2;border:1px solid #E3D6C3;border-radius:12px;box-shadow:0 12px 32px -12px rgba(43,33,24,.35);padding:16px 18px;color:#2B2118;font-size:14px;line-height:1.45;font-family:inherit}'
    + '.oa-mail-toast p{margin:0 0 10px !important;text-align:left !important}'
    + '.oa-mail-toast strong{font-weight:600}'
    + '.oa-mail-toast .oa-mail-actions{display:flex;flex-wrap:wrap;gap:8px}'
    + '.oa-mail-toast .oa-mail-actions a{display:inline-flex;align-items:center;padding:8px 14px;border-radius:6px;background:#4E7F50;color:#fff !important;text-decoration:none !important;font-weight:600;font-size:13px}'
    + '.oa-mail-toast .oa-mail-actions a:hover{background:#3C673E}'
    + '.oa-mail-toast .oa-mail-close{position:absolute;top:8px;right:10px;background:none;border:0;font-size:20px;line-height:1;color:#5A4F45;cursor:pointer;padding:4px}';

  function addStyle() {
    if (document.getElementById('oa-mail-style')) return;
    var s = document.createElement('style');
    s.id = 'oa-mail-style';
    s.textContent = STYLE;
    document.head.appendChild(s);
  }

  function copy(text) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text);
        return true;
      }
    } catch (e) {}
    try {
      var t = document.createElement('textarea');
      t.value = text;
      t.setAttribute('readonly', '');
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(t);
      return ok;
    } catch (e) { return false; }
  }

  function showToast(email, copied) {
    addStyle();
    var old = document.querySelector('.oa-mail-toast');
    if (old) old.remove();
    var enc = encodeURIComponent(email);
    var box = document.createElement('div');
    box.className = 'oa-mail-toast';
    box.setAttribute('role', 'status');
    box.innerHTML =
      '<button type="button" class="oa-mail-close" aria-label="Close">&times;</button>' +
      '<p>' + (copied ? '<strong>Email address copied:</strong> ' : '<strong>Our email:</strong> ') + email + '</p>' +
      '<p>If your email app didn\'t open, you can write to us in:</p>' +
      '<div class="oa-mail-actions">' +
        '<a href="https://mail.google.com/mail/?view=cm&fs=1&to=' + enc + '" target="_blank" rel="noopener">Gmail</a>' +
        '<a href="https://outlook.office.com/mail/deeplink/compose?to=' + enc + '" target="_blank" rel="noopener">Outlook</a>' +
      '</div>';
    document.body.appendChild(box);
    box.querySelector('.oa-mail-close').addEventListener('click', function () { box.remove(); });
    setTimeout(function () { if (box.parentNode) box.remove(); }, 12000);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.oc a[href^="mailto:"], .oc-wrap a[href^="mailto:"]');
    if (!a) return;
    var email = (a.getAttribute('href') || '').replace(/^mailto:/i, '').split('?')[0];
    if (!email) return;
    var copied = copy(email);
    // Let the normal mailto open the email app; show the fallback panel just after.
    setTimeout(function () { showToast(email, copied); }, 150);
  });
})();
